import React, { useMemo } from "react";
import PowerBi from "@pages/PowerBi";
import PageHeader from "@features/shared/components/PageHeader";

/**
 * DistributorInvoicing Component
 * Displays Distributor Invoicing FTD Power BI dashboard
 * Optimized with React.memo and useMemo
 */
const DistributorInvoicing = () => {
  // Memoized page configuration
  const pageName = useMemo(
    () => ({
      id: "fea60e84-eaf3-48a4-90ad-795360fb0878",
      name: "Distributor Invoicing - FTD",
    }),
    []
  );

  return (
    <>
      <PageHeader title="Distributor Invoicing FTD" path="/" />
      <div className="p-2">
        <PowerBi
          id="152a3955-1279-461a-bd81-da4db6e1d3f7"
          pageName={pageName}
          filterName="DimHierarchy"
          height="80vh"
        />
      </div>
    </>
  );
};

export default React.memo(DistributorInvoicing);